import React from 'react'
import PropTypes from 'prop-types'
import { SelectorDirect } from 'mage-deps/@klarna/bubble-ui'
import { EducationAnalytics } from 'education-tools'
import { useContentRank } from 'mage-cms'
import { useHelpContext } from './hooks'

ArticleList.propTypes = {
  articles: PropTypes.arrayOf(PropTypes.object).isRequired,
  analyticsCategory: PropTypes.string.isRequired
}

export default function ArticleList({ articles, analyticsCategory }) {
  const { navigation } = useHelpContext()

  const sortedArticles = useContentRank(articles)

  if (!sortedArticles || !sortedArticles.length) return null

  return (
    <>
      {sortedArticles.map((article, index) => (
        <EducationAnalytics
          key={article.id}
          category={analyticsCategory}
          action="print"
          label={article.title}
          referenceType="article"
          referenceId={article.id}
          payload={{ position: index + 1 }}
          googleAnalytics={false}
        />
      ))}

      <EducationAnalytics category={analyticsCategory} action="click" referenceType="article">
        {track => (
          <SelectorDirect
            id="uhqm-article-list"
            onSelect={article => {
              track({
                label: article.title,
                referenceId: article.id,
                payload: { position: sortedArticles.indexOf(article) + 1 }
              })
              navigation.push('article', { articleSlug: article.slug })
            }}
            options={getOptions(sortedArticles)}
          />
        )}
      </EducationAnalytics>
    </>
  )
}

function getOptions(articles) {
  return articles.map(article => ({ value: article, label: article.title }))
}
